import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { RiAlertFill } from 'react-icons/ri';
import { Col } from 'react-bootstrap';
import Text from '../Text';
import {
  OccurrenceListItemContainer,
  OccurrencesListContainer,
  StyledTotalPendencyOccurrences,
  TravelOccurrencesListContainer,
} from './styles';

export function TravelOccurrencesList({
  selectedOccurrence,
  setSelectedOccurrence,
  occurrences,
  show,
  onlyList = false,
  totalPendencyOccurrences = null,
  annulledList = false,
}) {
  function handleClick(occurrence) {
    if (
      selectedOccurrence?.id === occurrence.id &&
      !show.endOccurrence &&
      !show.addDescriptionToOccurrence &&
      !show.changeResponsible
    ) {
      setSelectedOccurrence({});
      return;
    }
    if (
      !show.endOccurrence &&
      !show.addDescriptionToOccurrence &&
      !show.changeResponsible
    ) {
      setSelectedOccurrence(occurrence);
    }
  }
  if (onlyList) {
    return (
      <TravelOccurrencesListContainer>
        <Text weight={500} type="body" color="dark">
          Ocorrências pendentes{' '}
          <StyledTotalPendencyOccurrences>
            {totalPendencyOccurrences}
          </StyledTotalPendencyOccurrences>
        </Text>
        <OccurrencesListContainer>
          {occurrences?.map(occurrence => {
            const description = occurrence?.descriptions[occurrence?.descriptions?.length - 1]?.description;
            return (
              <OccurrenceListItemContainer
                key={occurrence.id}
                selected={selectedOccurrence?.id === occurrence.id}
                finished={occurrence?.fullUserConclusion?.username}
                clickable={false}
                list
                title={
                  description || occurrence?.fullOccurrenceType?.name
                }
              >
                {occurrence.pendency &&
                  !occurrence?.fullUserConclusion?.username ? (
                  <RiAlertFill />
                ) : (
                  <FaCheck />
                )}
                {
                  description &&
                    description.trim() !== '' &&
                    description !== 'undefined' &&
                    description !== 'null' ? (
                    <Text type="regular" color="dark" weight={400}>
                      {
                        occurrence?.descriptions[
                          occurrence?.descriptions?.length - 1
                        ]?.description
                      }
                    </Text>
                  ) : (
                    <Col style={{ padding: 0, display: 'flex', gap: '5px' }}>
                      <Text type="regular" color="dark" weight={400}>
                        {occurrence?.fullOccurrenceType?.name}
                      </Text>
                      {occurrence?.occurrenceClientFields?.loadEmitted?.cteNumber && (
                        <Text type="regular" color="dark" weight={400}>
                          {`| ${occurrence?.occurrenceClientFields?.loadEmitted?.docType}: ${occurrence?.occurrenceClientFields?.loadEmitted?.cteNumber}`}
                        </Text>
                      )}
                    </Col>
                  )
                }
              </OccurrenceListItemContainer>
            );
          })}
        </OccurrencesListContainer>
      </TravelOccurrencesListContainer>
    );
  }
  return (
    <TravelOccurrencesListContainer>
      <Text weight={500} type="header" color="dark">
        {annulledList ? 'Ocorrências Anuladas' : 'Ocorrências'}
      </Text>
      <OccurrencesListContainer>
        {occurrences?.map(occurrence => {
          const description = occurrence?.descriptions[occurrence?.descriptions?.length - 1]?.description;
          return (
            <OccurrenceListItemContainer
              key={occurrence.id}
              selected={selectedOccurrence?.id === occurrence.id}
              onClick={() => handleClick(occurrence)}
              finished={occurrence.userConclusion}
              clickable={
                !show.endOccurrence &&
                !show.addDescriptionToOccurrence &&
                !show.changeResponsible
              }
              list={false}
            >
              {occurrence.pendency && !occurrence.userConclusion ? (
                annulledList ? (
                  <Text type="regular" color="red" weight={700}>
                    Ø
                  </Text>
                ) : (
                  <RiAlertFill />
                )
              ) : annulledList ? (
                <Text type="regular" color="red" weight={700}>
                  Ø
                </Text>
              ) : (
                <FaCheck />
              )}
              {
                description &&
                  description.trim() !== '' &&
                  description !== 'undefined' &&
                  description !== 'null' ? (
                  <Text type="regular" color="dark" weight={400}>
                    {
                      occurrence?.descriptions[
                        occurrence?.descriptions?.length - 1
                      ]?.description
                    }
                  </Text>
                ) : (
                  <Col style={{ padding: 0, display: 'flex', gap: '5px' }}>
                    <Text type="regular" color="dark" weight={400}>
                      {occurrence?.fullOccurrenceType?.name}
                    </Text>
                    {occurrence?.occurrenceClientFields?.loadEmitted?.cteNumber && (
                      <Text type="regular" color="dark" weight={400}>
                        {`| ${occurrence?.occurrenceClientFields?.loadEmitted?.docType}: ${occurrence?.occurrenceClientFields?.loadEmitted?.cteNumber}`}
                      </Text>
                    )}
                  </Col>
                )
              }
              <Text
                type="label"
                color="dark"
                weight={400}
                as="p"
                title={`Id da ocorrência ${occurrence.id}`}
              >
                {occurrence.id}
              </Text>
            </OccurrenceListItemContainer>
          );
        })}
      </OccurrencesListContainer>
    </TravelOccurrencesListContainer>
  );
}